
/* Browser back button Rebuy Data Fetch - start  */
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    Rebuy.Cart.init();
    document.addEventListener('rebuy:cart.ready', function(event){  Rebuy.SmartCart.hide(); }); 
  } 
});

/* Browser back button Rebuy Data Fetch - End  */

/* Function for remove Gift Wrap Product */
function removeGiftWrapFromCart(productKey){
  var strToChange = {};
  strToChange.updates = {};
  strToChange.updates[productKey] = 0;
  strToChange.note = "";
  
  // Ajax for the Remove Gift Wrap line Item
  $.ajax({
      url: "/cart/update.js",
      method: "POST",
      data: strToChange,	
      dataType: "json",
    success: function (result) {
      console.log("Success");
      //unblock checkbox
      //$(".tt-cart .rebuy-gift-wrap-checkbox").attr("disabled", false);
       $('.tt-cart .remaining-characters').css('color', '#6c6c6c');
       $('.tt-cart #rchars').text(0);
      //console.log(result);
    },
    error: function (result) {
      console.log("Error while rewmoving Gift Wrap Product");
      //console.log(result);
    }
  });	

  return true; 
}

function updateCartOrderNote(orderNote){
  var strToChange = {};
  strToChange.note = orderNote;
  console.log("Update Note");
  console.log(strToChange);

  // Ajax for the Remove Gift Wrap line Item
  $.ajax({
      url: "/cart/update.js",
      method: "POST",
      data: strToChange,	
      dataType: "json",
    success: function (result) {
      console.log("Success");
    },
    error: function (result) {
      console.log("Error while rewmoving Gift Wrap Product");
      //console.log(result);
    }
  });	

  return true; 
}

function addGiftWrapProductToCart(variantId){

  var flGiftWrapExist = false; 

  console.log("typeof(Rebuy)::");
  console.log(typeof(Rebuy));
  
  if( typeof(Rebuy) != "undefined" ){
    var rebuyCart =  Rebuy.SmartCart.cart; 
    if( rebuyCart.items.length > 0 ) {
      var rebuyCartItem = rebuyCart.items;

      for ( var itemKey in rebuyCartItem ){
        if(rebuyCartItem[itemKey]['variant_id'] == variantId){
           var flGiftWrapExist = true;
           break;
        }
      }
    }
  }

  console.log("flGiftWrapExist::");
  console.log(flGiftWrapExist);

  if( !flGiftWrapExist ){
    var cartProperties = {};
							
    cartProperties['_gift_wrap'] = "Y";
    
    var strToChange = {
      id : variantId,
      quantity: 1,
      properties: cartProperties,
    }
    
    var Cartitems = {};
    Cartitems['items'] = [];
    Cartitems.items.push(strToChange); 
  
    // Ajax for the Remove Gift Wrap line Item
    $.ajax({
        url: "/cart/add.js",
        method: "POST",
        data: Cartitems,	
        dataType: "json",
      success: function (result) {
        console.log("Success");
        //unblock checkbox
        //$(".tt-cart .rebuy-gift-wrap-checkbox").attr("disabled",false);
      },
      error: function (result) {
        console.log("Error while rewmoving Gift Wrap Product");
        console.log(result);
      }
    });	
    
  }
  else{
    if ( $('.tt-cart .rebuy-gift-wrap-checkbox:checked').length == 0 ){
      $('.tt-cart .rebuy-gift-wrap-checkbox').prop('checked', true) ;
    }
    $(".tt-cart .rebuy-gift-wrap-checkbox").attr("disabled", false);
  }
}
/* If non us customer then remove product from all the pages */
if(geoLocationCode != 'US'){
  document.addEventListener('rebuy:cart.change', (event) => {
    setTimeout(function(){
      if(event.detail.cart.cart.item_count >= 1){
        var cartItemsNew = event.detail.cart.cart.items;
        console.log("event")
        console.log(cartItemsNew);
        var arrRemoveProduct = {};
        arrRemoveProduct.updates = {};
        for (var i = 0; i < cartItemsNew.length; i++){
          var cartItemTags = cartItemsNew[i].product.tags;
          var cartItemSubscription = cartItemsNew[i].product.subscription;
          if(cartItemSubscription){
            arrRemoveProduct.updates[cartItemsNew[i].id] = 0;
          }
          if(cartItemTags.includes('Global-e Restricted')){
            arrRemoveProduct.updates[cartItemsNew[i].id] = 0;
          }
        }
        if(Object.keys(arrRemoveProduct.updates).length > 0){
          $.ajax({
              url: "/cart/update.js",
              method: "POST",
              data: arrRemoveProduct,
              dataType: "json",
            success: function (result) {
              console.log("Success");
              window.location.reload();
            },
            error: function (result) {
              console.log("Error while removing The Product");
            }
          });
        }
      }
    }, 1500);
  });
}




function rebuySmartCartCurrencyChange(){
  setTimeout(() => {
    /* Cart Recomendation */
     $('.rebuy-cart__flyout-item-info').each(function( index ) {
        var pricelength = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').length;
        var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();
        if( pricelength > 1 ){
          var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.sale').html();
          if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){
            var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
            $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.sale').html(newPriceHTML);
          }
          var priceCompareATHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.compare-at').html();          
          if(priceCompareATHTML != '' && priceCompareATHTML.includes('$') && !priceCompareATHTML.includes(localizationCurrecyCode)){
            var newPriceCompareHTML = priceCompareATHTML + ' ' + localizationCurrecyCode;
            $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.compare-at').html(newPriceCompareHTML);
          }
        }
        else{
          var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();
          if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){
            var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
            $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html(newPriceHTML);
          }
        }
    });
    
    $('.tt-cart .rebuy-product-block').each(function( index ) {
        var pricelength = $(this).find('.rebuy-product-price .rebuy-money').length;
        var priceHTML = $(this).find('.rebuy-product-price .rebuy-money span:nth-child(2)').html();      
        if( pricelength > 1 ){
          var priceHTML = $(this).find('.rebuy-product-price .rebuy-money.sale').html();
          if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){           
            var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
            $(this).find('.rebuy-product-price .rebuy-money.sale').html(newPriceHTML);
          }	  
          var priceCompareATHTML = $(this).find('.rebuy-product-price .rebuy-money.compare-at span:nth-child(2)').html();
          if(priceCompareATHTML != '' && priceCompareATHTML.includes('$') && !priceCompareATHTML.includes(localizationCurrecyCode)){           
            var newPriceCompareHTML = priceCompareATHTML + ' ' + localizationCurrecyCode;
            $(this).find('.rebuy-product-price .rebuy-money.compare-at span:nth-child(2)').html(newPriceCompareHTML);
          }	  	
        }
        else{
          // var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();
          if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){           
            var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;          
            $(this).find('.rebuy-product-price .rebuy-money span:nth-child(2)').html(newPriceHTML);
          }
          else{
            if( cartCurrencySymbol == "$" && !priceHTML.includes(localizationCurrecyCode) ){
        	  var newPriceHTML = priceHTML + '$ ' + localizationCurrecyCode;                 
        	  $(this).find('.rebuy-product-price .rebuy-money span:nth-child(2)').html(newPriceHTML);
        	}
          }
        }
    });
    
    
    /* SubTotal */
    if($('#rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').length > 0){
      var subtotal = $('#rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').html();
      if(subtotal.includes('$') && !subtotal.includes(localizationCurrecyCode)){
        $('.tt-cart #rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').html(subtotal + ' ' + localizationCurrecyCode);
      }
      else{
        if( cartCurrencySymbol == "$" && !subtotal.includes(localizationCurrecyCode) ){
          $('.tt-cart #rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').html(subtotal + '$ ' + localizationCurrecyCode);
        }
      }
    }

    /* Gift Product */
    if($('.tt-cart .rebuy-gift-cart__outer').length > 0){
      var giftProductPrice = $('.rebuy-gift-cart__outer .rebuy-money').html();
      if(giftProductPrice != '' && giftProductPrice.includes('$') && !giftProductPrice.includes(localizationCurrecyCode)){
          var newGiftPriceHTML = giftProductPrice + ' ' + localizationCurrecyCode;
      }
      $('.rebuy-gift-cart__outer .rebuy-money').html(newGiftPriceHTML);
    }
  } , 2000);
}
document.addEventListener('rebuy:smartcart.ready', function(event){ 

  /* Open Rebuy Cart when url contains smart-cart start */

  if (window.location.href.indexOf("smart-cart") > -1) {
      Rebuy.SmartCart.show();
  }

  /* Open Rebuy Cart when url contains smart-cart end */
  
  $("#rebuy-cart").prependTo(".tt-cart.tt-dropdown-obj");
  $('.tt-cart #rebuy-cart').removeAttr('hidden');
  if(geoLocationCode != "US"){
    $('.rebuy-cart__flyout-content .rebuy-cart__flyout-item-subscription').css('display','none')
  }
});   

document.addEventListener('rebuy:cart.change', function(event){  
  setTimeout(function(){

      if(geoLocationCode != "US"){
        $('.rebuy-cart__flyout-content .rebuy-cart__flyout-item-subscription').css('display','none');
      }
     /* Append Gift Wrap Product information to the Rebuy Samrt cart */
      if($('.gift-wrap-info').length > 0){
          if( $('.tt-cart .rebuy-cart .rebuy-gift-cart_checkbox').length ==  0 ){
            var htmlContent =   $('.gift-wrap-info').html();
            //$('.rebuy-cart__flyout-item.gift-wrap-item').prependTo('.rebuy-cart__flyout-footer');
            // $('.tt-cart .rebuy-cart__flyout-items .rebuy-cart__flyout-item:last').append(htmlContent);
            $( htmlContent ).insertBefore( $(".tt-cart .rebuy-cart__flyout-footer .rebuy-cart__flyout-subtotal") );
            $(".tt-cart .gift-wrap-info").css("display","");
          }
      }
     
    /* Check and hide the Kalrna Message if GlobalE country is out side of USA or have Any subscription Product */
    var nonUSCountryCustomer = false;
    
    var flDebug = false;
    var flagGiftWrapCart = false;
    var giftWrapProductKey = 0;
    var flagLargeCartItemExist = false;
    var flagEcomOutStockCartProductExist = false;
    
    //console.log('nonUSCountryCustomer', nonUSCountryCustomer); 
    var itemsObj = event.detail.cart.cart.items;    
    var orderNote = event.detail.cart.cart.note;
    var flagSubscriptionProduct  = false;
    var largeItemTag = 'LargeItem-IE-GiftWrap';
    var eComTag = '-ECOMMERCE-Available';
    var cartTotalItemCnt = event.detail.cart.cart.item_count; 

    var countItem = 1;
    for(itemKey in itemsObj){
      /* Check If Gift Wrap Product is exist into Cary or not*/
      if(giftCardProductId == itemsObj[itemKey].variant_id){
        flagGiftWrapCart = true;
        giftWrapProductKey = itemsObj[itemKey].variant_id;
      }
      else{
        /* Check if Larg Item Product Exist into the Cart Or Not */
        var productTags = itemsObj[itemKey].product.tags;
        if(productTags.includes(largeItemTag)){
          flagLargeCartItemExist = true;
        }
  
        /* Check if any product having no inventory at Ecommerce Location exist  */
        var variantEcomLocationTag =  itemsObj[itemKey].sku + eComTag; 
        if(!productTags.includes(variantEcomLocationTag)){
          flagEcomOutStockCartProductExist = true;
        }
      }
        
      if(typeof(itemsObj[itemKey].selling_plan_allocation) != "undefined" ){
        var flagSubscriptionProduct  = true;
      }      
      if(typeof(itemsObj[itemKey].properties._final_sale) == "undefined"){
        if(itemsObj[itemKey].product.tags.includes("Final Sale")){          
          var customIndex = itemsObj[itemKey].key;
          var customProps = itemsObj[itemKey].properties;
          var customQuantity = parseInt(itemsObj[itemKey].quantity);
          customProps._final_sale = "Y";          
          var strToChange = {
            id: customIndex,
            properties: customProps,
            quantity: customQuantity
          };
           fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(strToChange)
          });
        }
      }
      countItem++;
    }

     var GlobalEIntervalMiniCart = setInterval(function(){

        clearInterval(GlobalEIntervalMiniCart);
        if(geoLocationCode != "US"){
          nonUSCountryCustomer = true;
        }
        if (geoLocationCode == "US") {
        // if (GlobalE.Country == "us") {
          $(".tt-cart .rebuy-gift-cart__outer").removeClass("other-country-selected");
        } else {
          $(".tt-cart .rebuy-gift-cart__outer").addClass("other-country-selected");
        }
        // console.log("flagGiftWrapCart : " + flagGiftWrapCart);
        if(flDebug){
          console.log("US Customer: " + nonUSCountryCustomer);
          console.log("Cart Contain GiftWrap Product: " + flagGiftWrapCart);
          console.log("GiftWrap Product Index in cart: " + giftWrapProductKey);
          console.log("Cart Contain any large product: " + flagLargeCartItemExist);
          console.log("Cart Order Note: " + orderNote);
          console.log("Cart Contain any Product not having quantity avaialble at Ecommerece Locatrion: " + flagEcomOutStockCartProductExist);
        }


        /* Remove Gift Wrap Product in case of noy any other product exist into cart  */
        if(cartTotalItemCnt == 1 && flagGiftWrapCart){
          removeGiftWrapFromCart(giftWrapProductKey);
        }

         //unblock Gift Wrap checkbox
        $(".tt-cart .rebuy-gift-wrap-checkbox").attr("disabled", false);

        //For forcefully scroll text area
        if ($("html").hasClass('touch-device')) {
          $('.gift-wrap-note').unbind('focus');
          $('.gift-wrap-note').focus(function(){
            var offsetOuter = $('.rebuy-gift-cart__outer').offset();
            $('html,body').animate({ scrollTop: offsetOuter.top });
          });
        }

        /* Trigger Event when Gift Wrapping Checkbox checked */
        $( ".tt-cart .rebuy-gift-cart__outer .rebuy-gift-wrap-checkbox").unbind( "change" );
        $(".tt-cart .rebuy-gift-wrap-checkbox").change(function() {
            if(this.checked) {
                // temporary block  checkbox
                $(".tt-cart .rebuy-gift-wrap-checkbox").attr("disabled",true);
                // Show Text area gift note
                $('.tt-cart .rebuy-print-msg-outer').css('display', 'block');
                // Function call for add Gift Wrap product
                addGiftWrapProductToCart(giftCardProductId);
            }
            if(!this.checked){
              // temporary block  checkbox
              $(".tt-cart .rebuy-gift-wrap-checkbox").attr("disabled",true);
              //Display Gift note section
             $('.tt-cart .rebuy-print-msg-outer').css('display', 'none');
              removeGiftWrapFromCart(giftCardProductId);
            }
        });

        /* function for maxlength */
        $('.tt-cart #txtAreaGiftNote').unbind("keyup");
        var maxLength = 200;
        $('.tt-cart #txtAreaGiftNote').keyup(function() {
          //var textlen = maxLength - $(this).val().length;
          var textlen = $(this).val().length;
          $('.tt-cart #rchars').text(textlen);

          if(textlen >= 200){
            $('.tt-cart .remaining-characters').css('color', 'red');
          }
          else{
            $('.tt-cart .remaining-characters').css('color', '#6c6c6c');
          }
        });

        /* For Show/Hide Gift wrap product  */
        if(flagGiftWrapCart){
          if(flagLargeCartItemExist || flagEcomOutStockCartProductExist || nonUSCountryCustomer){
            /* Remove Gift wrap product from the cart */
            removeGiftWrapFromCart(giftWrapProductKey);
          }
          else{
             /* Display Gift Wrap Product section in Rebuy  */
             // Show Giftwrap checkbox checked
             $('.tt-cart .rebuy-gift-wrap-checkbox').prop('checked', true);

             //Display Gift note section
             $('.tt-cart .rebuy-print-msg-outer').css('display', 'block');

              /* Function for Gift Note update */
              $('.tt-cart #txtAreaGiftNote').unbind( "blur" );
              $('.tt-cart #txtAreaGiftNote').blur(function(){
                // alert($('.rebuy-print-msg-outer .rebuy-form-control').val());
                if( $('#txtAreaGiftNote').val() != ""){
                  var note =  $('.tt-cart #txtAreaGiftNote').val();
                  $(".tt-cart .rebuy-gift-wrap-checkbox").attr("disabled",true);
                  updateCartOrderNote(note);
                }
              });

            //Check if Gift Wrap note is already added or not
            if(orderNote != "" && orderNote != null ){
              $('.tt-cart .rebuy-print-msg-outer .rebuy-form-control').val(orderNote);

              var orderNoteLength = orderNote.length;

              $('.tt-cart #rchars').text(orderNoteLength);

              if(orderNoteLength >= 200){
                $('.tt-cart .remaining-characters').css('color', 'red');
              }
              else{
                $('.tt-cart .remaining-characters').css('color', '#6c6c6c');
              }
            }
            else{
              $('.tt-cart .remaining-characters').css('color', '#6c6c6c');
              $('.tt-cart #rchars').text(0);
            }
          }
        }
        else{
          if(!flagLargeCartItemExist && !flagEcomOutStockCartProductExist && !nonUSCountryCustomer){

            $('.tt-cart .rebuy-gift-wrap-checkbox').prop('checked', false);

            //Remove hidden class in case if append
            $(".tt-cart .rebuy-gift-cart__outer").removeClass("other-country-selected");

            //Hide Text area gift note
            $('.tt-cart .rebuy-print-msg-outer').css('display', 'none');

            //blank order note
            $('.tt-cart .rebuy-print-msg-outer .rebuy-form-control').val('');
          }
          else{

            //Hide Gift Wrapping
            $(".tt-cart .rebuy-gift-cart__outer").addClass("other-country-selected");

            //Hide Text area gift note
            $('.tt-cart .rebuy-print-msg-outer').css('display', 'none');

          }
        }

        if( flagSubscriptionProduct || nonUSCountryCustomer ){
          $('#rebuy-cart #div-mini-cart-klarna-design-1').css('display', 'none');
        }
        else{
           $('#rebuy-cart #div-mini-cart-klarna-design-1').css('display', '');
        }
        $('#rebuy-cart #div-mini-cart-klarna-design-1').attr("data-purchase-amount",""+event.detail.cart.cart.items_subtotal_price+"");
        if(!nonUSCountryCustomer){
          setTimeout(function(){
            window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
            window.Klarna.OnsiteMessaging.refresh();
          }, 250);
        }
        else{
           $('#rebuy-cart #div-mini-cart-klarna-design-1').css('display', 'none');
        }
    },50);                        
  }, 1000);
}); 


document.addEventListener('rebuy:smartcart.hide', function(event){
  if($(".sticky-footer").length > 0){
    $(".sticky-footer").css("z-index","9999")
  }
}); 

/* Smart Cart on show */
document.addEventListener('rebuy:smartcart.show', function(event){

   if($(".sticky-footer").length > 0){
      $(".sticky-footer").css("z-index","9")
    }
  
  /* Cart Recomendation */
   $('.tt-cart .rebuy-cart__flyout-item-info').each(function( index ) {
      var pricelength = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').length;
      var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();     
      if( pricelength > 1 ){
        var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.sale').html();
        if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){
          var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
          $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.sale').html(newPriceHTML);
        }         
        var priceCompareATHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.compare-at').html();        
        if(priceCompareATHTML != '' && priceCompareATHTML.includes('$') && !priceCompareATHTML.includes(localizationCurrecyCode)){
          var newPriceCompareHTML = priceCompareATHTML + ' ' + localizationCurrecyCode;
          $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.compare-at').html(newPriceCompareHTML);
        }
      }
      else{
        var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();
        if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){
          var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
          $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html(newPriceHTML);
        }
         else{
              if( cartCurrencySymbol == "$" && !priceHTML.includes(localizationCurrecyCode) ){
                var newPriceHTML = priceHTML + '$ ' + localizationCurrecyCode;                 
                $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html(newPriceHTML);
              }
            }
      }
  });

  /* SubTotal */
  if($('#rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').length > 0){
    var subtotal = $('#rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').html();
    if(subtotal.includes('$') && !subtotal.includes(localizationCurrecyCode)){
      $('.tt-cart #rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').html(subtotal + ' ' + localizationCurrecyCode)
    }
    else{      
        if( cartCurrencySymbol == "$" && !subtotal.includes(localizationCurrecyCode) ){
          $('.tt-cart #rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').html(subtotal + '$ ' + localizationCurrecyCode);
        }
      }
  }

  /* Gift Product */
  if($('.tt-cart .rebuy-gift-cart__outer').length > 0){
    var giftProductPrice = $('.rebuy-gift-cart__outer .rebuy-money').html();
    if(giftProductPrice != '' && giftProductPrice.includes('$') && !giftProductPrice.includes(localizationCurrecyCode)){
        var newGiftPriceHTML = giftProductPrice + ' ' + localizationCurrecyCode;
    }
    $('.rebuy-gift-cart__outer .rebuy-money').html(newGiftPriceHTML);
  }


});

document.addEventListener('rebuy.ready', function(event){

  /* Product Recomendation */
  setTimeout(function(){

    $('.tt-cart .rebuy-product-block').each(function( index ) {
        var pricelength = $(this).find('.rebuy-product-price .rebuy-money').length;
        var priceHTML = $(this).find('.rebuy-product-price .rebuy-money span:nth-child(2)').html();      
        if( pricelength > 1 ){
          var priceHTML = $(this).find('.rebuy-product-price .rebuy-money.sale').html();
          if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){           
            var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
            $(this).find('.rebuy-product-price .rebuy-money.sale').html(newPriceHTML);
          }	  
          var priceCompareATHTML = $(this).find('.rebuy-product-price .rebuy-money.compare-at span:nth-child(2)').html();
          if(priceCompareATHTML != '' && priceCompareATHTML.includes('$') && !priceCompareATHTML.includes(localizationCurrecyCode)){           
            var newPriceCompareHTML = priceCompareATHTML + ' ' + localizationCurrecyCode;
            $(this).find('.rebuy-product-price .rebuy-money.compare-at span:nth-child(2)').html(newPriceCompareHTML);
          }	  	
        }
        else{
          // var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();
          if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){           
            var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;          
            $(this).find('.rebuy-product-price .rebuy-money span:nth-child(2)').html(newPriceHTML);
          }
          else{
            if( cartCurrencySymbol == "$" && !priceHTML.includes(localizationCurrecyCode) ){
        	  var newPriceHTML = priceHTML + '$ ' + localizationCurrecyCode;                 
        	  $(this).find('.rebuy-product-price .rebuy-money span:nth-child(2)').html(newPriceHTML);
        	}
          }
        }
    });

  }, 800);
});


document.addEventListener('rebuy:cart.change', function(event){
   setTimeout(function(){
     /* Cart Recomendation */
       $('.tt-cart .rebuy-cart__flyout-item-info').each(function( index ) {         
          var pricelength = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').length;
          var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();         
          if( pricelength > 1 ){
            var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.sale').html();
            if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){
              var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
              $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.sale').html(newPriceHTML);
            }            
            var priceCompareATHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.compare-at').html();            
            if(priceCompareATHTML != '' && priceCompareATHTML.includes('$') && !priceCompareATHTML.includes(localizationCurrecyCode)){
              var newPriceCompareHTML = priceCompareATHTML + ' ' + localizationCurrecyCode;
              $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.compare-at').html(newPriceCompareHTML);
            }
          }
          else{
            var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();
            if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){
              var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
              $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html(newPriceHTML);
            }
            else{
              if( cartCurrencySymbol == "$" && !priceHTML.includes(localizationCurrecyCode)){
                var newPriceHTML = priceHTML + '$ ' + localizationCurrecyCode;                 
                $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html(newPriceHTML);
              }
            }
          }
      });

      /* Gift Product */
      if($('.tt-cart .rebuy-gift-cart__outer').length > 0){
        var giftProductPrice = $('.rebuy-gift-cart__outer .rebuy-money').html();
        if(giftProductPrice != '' && giftProductPrice.includes('$') && !giftProductPrice.includes(localizationCurrecyCode)){
            var newGiftPriceHTML = giftProductPrice + ' ' + localizationCurrecyCode;
        }
        $('.rebuy-gift-cart__outer .rebuy-money').html(newGiftPriceHTML);
      }
  }, 200);

});

document.addEventListener('rebuy.productsChange', function(event){

   /* Product Recomendation */
  setTimeout(function(){
    $('.tt-cart .rebuy-product-block').each(function( index ) {
        var pricelength = $(this).find('.rebuy-product-price .rebuy-money').length;
        var priceHTML = $(this).find('.rebuy-product-price .rebuy-money span:nth-child(2)').html();           
        if( pricelength > 1 ){
          var priceHTML = $(this).find('.rebuy-product-price .rebuy-money.sale').html();
          if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){           
            var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
            $(this).find('.rebuy-product-price .rebuy-money.sale').html(newPriceHTML);
          }	  
          var priceCompareATHTML = $(this).find('.rebuy-product-price .rebuy-money.compare-at span:nth-child(2)').html();
          if(priceCompareATHTML != '' && priceCompareATHTML.includes('$') && !priceCompareATHTML.includes(localizationCurrecyCode)){           
            var newPriceCompareHTML = priceCompareATHTML + ' ' + localizationCurrecyCode;
            $(this).find('.rebuy-product-price .rebuy-money.compare-at span:nth-child(2)').html(newPriceCompareHTML);
          }	  	
        }
        else{
          // var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();
          if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){           
            var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;          
            $(this).find('.rebuy-product-price .rebuy-money span:nth-child(2)').html(newPriceHTML);
          }
          else{
            if( cartCurrencySymbol == "$" && !priceHTML.includes(localizationCurrecyCode) ){
        	  var newPriceHTML = priceHTML + '$ ' + localizationCurrecyCode;                 
        	  $(this).find('.rebuy-product-price .rebuy-money span:nth-child(2)').html(newPriceHTML);
        	}
          }
        }
    });

    
      if($('.tt-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').length > 0){
        var subtotal = $('.tt-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').html();
        //alert(subtotal);
        if(subtotal.includes('$') && !subtotal.includes(localizationCurrecyCode) ){
          $('.tt-cart #rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').html(subtotal + ' ' + localizationCurrecyCode)
        }
        else{
          if( cartCurrencySymbol == "$" && !subtotal.includes(localizationCurrecyCode) ){
            $('.tt-cart #rebuy-cart .rebuy-cart__flyout-subtotal .rebuy-cart__flyout-subtotal-amount').html(subtotal + '$ ' + localizationCurrecyCode);
          }
        }
      }


      $('.tt-cart .rebuy-cart__flyout-item-info').each(function( index ) {
          var pricelength = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').length;
          var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();
          if( pricelength > 1 ){
            var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.sale').html();
            if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){
              var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
              $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.sale').html(newPriceHTML);
            }
            var priceCompareATHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.compare-at').html();
            if(priceCompareATHTML != '' && priceCompareATHTML.includes('$') && !priceCompareATHTML.includes(localizationCurrecyCode)){
              var newPriceCompareHTML = priceCompareATHTML + ' ' + localizationCurrecyCode;
              $(this).find('.rebuy-cart__flyout-item-price .rebuy-money.compare-at').html(newPriceCompareHTML);
            }
          }
          else{
            var priceHTML = $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html();
            if(priceHTML != '' && priceHTML.includes('$') && !priceHTML.includes(localizationCurrecyCode)){
              var newPriceHTML = priceHTML + ' ' + localizationCurrecyCode;
              $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html(newPriceHTML);
            }
            else{
            	if( cartCurrencySymbol == "$" && !priceHTML.includes(localizationCurrecyCode) ){
            	  var newPriceHTML = priceHTML + '$ ' + localizationCurrecyCode;                 
            	  $(this).find('.rebuy-cart__flyout-item-price .rebuy-money').html(newPriceHTML);
            	}
            }
          }
      });

     /* Gift Product */
  if($('.tt-cart .rebuy-gift-cart__outer').length > 0){
    var giftProductPrice = $('.rebuy-gift-cart__outer .rebuy-money').html();
    if(giftProductPrice != '' && giftProductPrice.includes('$') && !giftProductPrice.includes(localizationCurrecyCode)){
        var newGiftPriceHTML = giftProductPrice + ' ' + localizationCurrecyCode;
    }
    $('.rebuy-gift-cart__outer .rebuy-money').html(newGiftPriceHTML);
  }

  }, 200);

});